// This file is generated by scripts/write-app-version.js.
// Do not edit it manually.
export const CURRENT_APP_BUILD_ID = "60.11.637-339ca3ce-1793720573814"
export const CURRENT_APP_VERSION = "60.11.637"
export const CURRENT_APP_BUILD_TIME = "2026-11-03T15:42:53.657Z"
